
import { formatByCountry, parseByCountry } from "@/app/infrastructures/misc/Utils";
import { CargoController } from "@/app/ui/controllers/CargoController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { CargoDetailStt } from "@/domain/entities/Cargo";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import { Options, prop, Vue } from "vue-class-component";

@Options({
  components: {
    Accordion,
    AccordionTab
  }
})
export default class WeightSummaryStt extends Vue {
  buttonText = "Tutup";

  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  get chargeableWeight() {
    return CargoController.sttResultFinal.length
      ? Math.max(1, this.volumeWeight, this.grossWeight)
      : 0;
  }

  get volumeWeight() {
    return CargoController.totalSttVolumeWeight;
  }

  get grossWeight() {
    return CargoController.totalSttGrossWeight;
  }

  convertDecimal(value: string | number) {
    const num = typeof value === "string" ? parseByCountry(value, { country: this.countryCode }) : Number(value);
    return formatByCountry(num, { type: "weight", country: this.countryCode });
  }
}
